<template>
  <v-file-input ref="campo"
    v-bind="attrs"
    v-model="model"
    small-chips
    prepend-inner-icon="mdi-paperclip"
    prepend-icon=""
    :rules="rules"
    :label="labelDefault"
    v-on="$listeners"
    :data-cy="attrs.label || attrs.name">
  <template v-for="(_, slotName) in $scopedSlots" v-slot:[slotName]="context">
    <slot :name="slotName" v-bind="context" />
  </template>
    <template v-for="(_, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
    <template v-if="!$scopedSlots.message" v-slot:message="{ message, key }">
      <v-icon v-if="$api.UI.showErrorIcon($el)" x-small color="error" class="mr-1 pb-1">{{$theme.options.iconError}}</v-icon>
      <span v-html="message" :key="key"></span>
    </template>
  </v-file-input>
</template>
<script>
export default {
  props: {
    value: null,
    change: Function
  },
  computed: {
    labelDefault: function () {
      return (
        this.$attrs.label ? this.$attrs.label +
        (this.$attrs.required === '' || this.$attrs.required === true ? ' *' : '')
          : ''
      )
    },
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    attrs () {
      return { ...this.$theme.options, ...this.$theme.options.file, ...this.$attrs }
    },
    rules () {
      const errors = []
      const name = this.$attrs.name || this.$attrs.label || ''
      if (this.$attrs.required === '' || this.$attrs.required === true) {
        !!this.model || errors.push(name + ' é obrigatório.')
      }

      this.$api.UTIL.Functions.ValidateFormRules(this.$attrs.rules, errors, this.model)

      if (this.$attrs['max-size'] && this.value) {
        if (this.value.size) {
          try {
            const max = parseInt(
              this.$attrs['max-size'].replace(/[aA-zZ]/g, '')
            )
            const unit = this.$attrs['max-size'].replace(/\d/g, '')
            let val = this.value.size
            if (unit.toUpperCase() === 'KB') {
              val = val / 1024
            }
            if (unit.toUpperCase() === 'MB') {
              val = val / (1024 * 1024)
            }
            if (unit.toUpperCase() === 'GB') {
              val = val / (1024 * 1024 * 1024)
            }
            if (val > max) {
              errors.push(
                name +
                  ': Tamanho máximo do arquivo é de ' +
                  this.$attrs['max-size'] + '.'
              )
            }
          } catch {
            // continue regardless of error
          }
        }
      }

      if (this.$refs && this.$refs.campo && this.$refs.campo.$el) {
        this.$refs.campo.$el.setAttribute(
          'data-message',
          errors ? errors[0] : ''
        )
        this.$refs.campo.$el.setAttribute('data-invalid', errors.length > 0)
      }

      return errors
    }
  },
  mounted () {
    this.$nextTick(function () {
      const errors = this.rules
      this.$el.setAttribute('data-message', errors ? errors[0] : '')
      this.$el.setAttribute('data-invalid', errors.length > 0)
    })
  }
}
</script>
